import React from "react";
import { Card, Image } from "react-bootstrap";
import moment from "moment";
import "./BlogCard.css";

const BlogCard = ({ blog = {}, viewBlog }) => {
  const {
    cover_img,
    title = "Untitled Blog",
    createdAt,
    tags = [],
    summary = "",
  } = blog;

  const fallbackImg = "/img/blog/placeholder.jpg";

  return (
    <Card
      className="h-100 shadow-sm border-0 hover-shadow blog-card"
      onClick={() => viewBlog(blog)}
      style={{ cursor: "pointer" }}
    >
      <div className="ratio ratio-16x9 overflow-hidden rounded-top">
        <Image
          src={cover_img || fallbackImg}
          alt={title}
          fluid
          style={{ objectFit: "cover" }}
        />
      </div>

      <Card.Body>
        <div className="d-flex justify-content-between text-muted small mb-2">
          <span>{moment(createdAt || new Date()).format("MMM D, YYYY")}</span>
          {tags?.[0] && <span className="text-capitalize">{tags[0]}</span>}
        </div>

        <Card.Title as="h5" className="text-truncate" title={title}>
          {title}
        </Card.Title>

        {summary && (
          <Card.Text className="text-muted small">
            {summary.length > 100 ? summary.slice(0, 100) + "..." : summary}
          </Card.Text>
        )}
      </Card.Body>
    </Card>
  );
};

export default BlogCard;
